module.exports = __webpack_public_path__ + "img/IMG_1231_L_Black.f0e91b8c.jpg";